import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DxListModule, DxLoadIndicatorModule } from 'devextreme-angular';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { FavoriteFilterListComponent } from './favorite-filter-list/favorite-filter-list.component';
import { FavoritesComponent } from './favorites.component';

@NgModule({
  imports: [
    CommonModule,
    MatListModule,
    MatIconModule,
    FlexLayoutModule,
    DxListModule,
    DxLoadIndicatorModule,
    MatTooltipModule,
  ],
  declarations: [FavoritesComponent, FavoriteFilterListComponent],
  exports: [FavoritesComponent],
})
export class FavoritesModule {}
